export default "__VITE_ASSET__C3LMroe9__"